export default {
  runtimeConstant: {
    isDebugConfigs: false,
    isDebugDirectives: false,
    isDebugFilters: false,
    isDebugRunners: false,
    isDebugRunnersInternals: false,
    isDebugRunnersTransitions: false,
    isDebugServices: false,
    isDebugServicesInternals: false,
    isDebugModels: false,
    isDebugModelsInternals: false,
    isDebugControllers: false,
    isDebugControllersInternals: false,
    shouldLoadCompanyImage: false,
  },
};
